import {
  Box,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useState } from "react";

const ProductRow = ({ product, onEdit, onDelete,onView }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  return (
    <Box className="grid grid-cols-6 items-center py-4 border-b hover:bg-gray-50 transition">

      {/* Product Info */}
      <Box className="flex items-center gap-3">
        {/* <Avatar
          src={product.images}
          variant="rounded"
          sx={{ width: 50, height: 50 }}
        /> */}
        <Avatar
            src={product.mainImage || product.otherImages[0]  }
            variant="rounded"
            sx={{ width: 50, height: 50 }}
          />
        <Typography>{product.name}</Typography>
      </Box>

      <Typography>{product.category}</Typography>
      <Typography>₹ {product.price}</Typography>
      <Typography>{product.sizes?.join(", ")}</Typography>
      <Typography>In Stock</Typography>

      {/* 3 Dot Menu */}
      <Box className="flex justify-end">
        <IconButton
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          <MoreVertIcon />
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={() => setAnchorEl(null)}
        >
              <MenuItem
    onClick={() => {
      onView(product);
      setAnchorEl(null);
    }}
  >
    View
  </MenuItem>
          <MenuItem
            onClick={() => {
              onEdit(product);
              setAnchorEl(null);
            }}
          >
            Edits
          </MenuItem>

          <MenuItem
            onClick={() => {
              onDelete(product._id);
              setAnchorEl(null);
            }}
          >
            Delete
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
};

export default ProductRow;
